import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=a78bacde"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=a78bacde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports